import React from 'react';
const DEFAULT_CONTEXT = {
    embedded: false,
    surface: null
};
/**
 * Context provided by SidePanelHost / floating windows to nested panel UIs.
 */
export const SidePanelEmbedContext = React.createContext(DEFAULT_CONTEXT);
/**
 * Hook for panels that need to adapt chrome when embedded.
 *
 * @returns {ISidePanelEmbedContext}
 */
export function useSidePanelEmbed() {
    return React.useContext(SidePanelEmbedContext);
}
